import {
  BaseButton,
  Props as BaseButtonProps,
} from '../LegacyButton/BaseButton';

export const ButtonNavButton = (props: BaseButtonProps) => {
  return <BaseButton {...props} size="small" />;
};
